import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { ChangeEvent, useEffect, useState, Dispatch } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { startOfYear } from 'date-fns';
import { useSession, xapi } from '../../hooks/session';
import SwLoading from './spinner/SwLoading';
import mapPinIcon from '../../images/sub/map_pin.svg';
import openBookIcon from '../../images/sub/open_book.svg';
import walkingManIcon from '../../images/sub/waking_man.svg';
import {
  KEY_USER_READ_LIST,
  KEY_USER_STEP_LIST,
  KEY_USER_WRITE_LIST,
} from '../../common/key';

import {
  commaFormat,
  convert2Date,
  DATE_LOCALE_OFFSET,
  encodeSearchWord,
  firstDayOfMonth,
  formatDateString,
  getCurrentStartDate,
  lastDayOfMonth,
} from '../../common/helper';
import {
  getUserReadList,
  getUserStepList,
  getUserWriteList,
} from '../../common/api/ApiUser';
import { SwSelectMonth } from './SwSelectMonth';
import NoDataPage from './NoDataPage';
import { EmptyPage } from './EmptyPage';
import { SwPagination } from './tableElement/SwPagination';

const columns = ['도서 제목', '출판사', '저자', '등록일자'];
const columnsR = ['도서 제목', '출판사', '저자', '읽기 시작일'];
const columnsF = ['도서 제목', '출판사', '저자', '읽기 시작일', '완독일'];
const stepColumns = ['날짜', '걸음수'];
const DEFAULT_WIDTH = '4rem';

interface Props {
  memberSeq: number;
  open: boolean;
  onClose: () => void;
}

export const SwUserStatDetail: React.FC<Props> = ({
  memberSeq,
  open,
  onClose,
}) => {
  const { loginVal } = useSession();
  const queryClient = useQueryClient();
  const [requestList, setRequestList] = useState<any>([]);
  const [bookSeq, setBookSeq] = useState<number>(-1);
  const [tabValue, setTabValue] = useState<number>(0);
  const [readType, setReadType] = useState<string>('like');
  const [writeItem, setWriteItem] = useState<string>('0');
  const [targetMonth, setTargetMonth] = useState<any>(getCurrentStartDate());
  const [rangeDate, setRangeDate] = useState([
    startOfYear(new Date()), // 올해 1월 1일
    new Date(), // 오늘
  ]);
  const [loading, setLoading] = useState<any>(false);
  const [searchKey, setSearchKey] = useState<string>('read');
  const [searchWord, setSearchWord] = useState<string>('');
  const rowsPerPageOptions = [5, 10, 15, 20];
  const [writePage, setWritePage] = useState(1);
  const [stepPage, setStepPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [stepRowsPerPage, setStepRowsPerPage] = useState(10);
  const [description, setDescription] = useState<string>(
    '텍스트가 이곳에 나옵니다. 텍스트가 이곳에 나옵니다. 텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.나옵니다.텍스트가 이곳에 나옵니다.나옵니다.텍스트가 이곳에 나옵니다.나옵니다.텍스트가 이곳에 나옵'
  );

  const {
    data,
    isLoading,
    refetch: refetchUserRead,
  } = useQuery(
    KEY_USER_READ_LIST,
    () => {
      if (open) {
        const newData: any = {
          type: 'cumulative',
          seq: memberSeq,
          page: 0,
          rowsPerPage: 0,
          searchKey: searchKey,
          searchWord: encodeSearchWord(searchKey, searchWord),
          startDate: rangeDate[0] === null ? 0 : rangeDate[0].getTime(),
          endDate: rangeDate[1] === null ? 0 : rangeDate[1].getTime(),
        };
        return getUserReadList(newData);
      }
      return null;
    },
    {
      onSuccess: res => {
        setLoading(false);
        if (res !== null) {
          setRequestList(res.readList);
        } else {
          setRequestList([]);
        }
      },
      onError: e => {
        setLoading(false);
        console.log(e);
      },
    }
  );

  const { refetch: refetchUserStep } = useQuery(
    KEY_USER_STEP_LIST,
    () => {
      if (open) {
        const newData: any = {
          seq: memberSeq,
          page: stepPage,
          rowsPerPage: stepRowsPerPage,
          searchKey: searchKey,
          searchWord: encodeSearchWord(searchKey, searchWord),
          startDate: rangeDate[0] === null ? 0 : rangeDate[0].getTime(),
          endDate: rangeDate[1] === null ? 0 : rangeDate[1].getTime(),
        };
        return getUserStepList(newData);
      }
      return null;
    },
    {
      onSuccess: res => {
        setLoading(false);
        if (res !== null) {
          setRequestList(res.stepList);
          setTotalRecords(res.totalRecordCount);
        } else {
          setRequestList([]);
        }
      },
      onError: e => {
        setLoading(false);
        console.log(e);
      },
    }
  );

  const prefetchUserStep = (newPage: number) => {
    queryClient.prefetchQuery(KEY_USER_STEP_LIST, () => {
      const newData: any = {
        seq: memberSeq,
        page: stepPage,
        rowsPerPage: stepRowsPerPage,
        searchKey: searchKey,
        searchWord: encodeSearchWord(searchKey, searchWord),
        startDate: rangeDate[0] === null ? 0 : rangeDate[0].getTime(),
        endDate: rangeDate[1] === null ? 0 : rangeDate[1].getTime(),
      };
      return getUserStepList(newData);
    });
  };

  const { refetch: refetchUserWrite } = useQuery(
    KEY_USER_WRITE_LIST,
    () => {
      if (open) {
        const newData: any = {
          seq: memberSeq,
          page: writePage,
          rowsPerPage: 1,
          searchKey: searchKey,
          searchWord: encodeSearchWord(searchKey, searchWord),
          startDate: rangeDate[0] === null ? 0 : rangeDate[0].getTime(),
          endDate: rangeDate[1] === null ? 0 : rangeDate[1].getTime(),
        };
        return getUserWriteList(newData);
      }
      return null;
    },
    {
      onSuccess: res => {
        setLoading(false);
        if (res !== null) {
          setRequestList(res.writeList);
          setTotalRecords(res.totalRecordCount);
        } else {
          setRequestList([]);
        }
      },
      onError: e => {
        setLoading(false);
        console.log(e);
      },
    }
  );

  const prefetchUserWrite = (newPage: number) => {
    queryClient.prefetchQuery(KEY_USER_WRITE_LIST, () => {
      const newData: any = {
        seq: memberSeq,
        page: newPage,
        rowsPerPage: 1,
        searchKey: searchKey,
        searchWord: encodeSearchWord(searchKey, searchWord),
        startDate: rangeDate[0] === null ? 0 : rangeDate[0].getTime(),
        endDate: rangeDate[1] === null ? 0 : rangeDate[1].getTime(),
      };
      return getUserWriteList(newData);
    });
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    newValue === 0
      ? refetchUserRead()
      : newValue === 1
      ? refetchUserStep()
      : refetchUserWrite();
  };

  const downloadUserRwwList = (param: any) =>
    xapi
      .get(
        `/admin/v1/apis/user/${param.seq}/download/rww?searchKey=${param.searchKey}&searchWord=${param.searchWord}&startDate=${param.startDate}&endDate=${param.endDate}`,
        { responseType: 'blob' }
      )
      .then(res => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `user_rww.xlsx`;
        document.body.appendChild(a);
        a.click();
        setTimeout((_: any) => {
          window.URL.revokeObjectURL(url);
        }, 600000);
        a.remove();
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        console.error('err: ', err);
      });

  const downloadItem = () => {
    const newData = {
      seq: memberSeq,
      searchKey: 'user-rww',
      searchWord: '',
      startDate: rangeDate[0] === null ? 0 : rangeDate[0].getTime(),
      endDate: rangeDate[1] === null ? 0 : rangeDate[1].getTime(),
    };
    setLoading(true);
    downloadUserRwwList(newData);
  };

  const clickReadType = (newReadType: string) => {
    setReadType(newReadType);
    const newDatas = requestList.filter(
      (row: any) =>
        row.type === newReadType || `${row.type}${row.status}` === newReadType
    );
    setTotalRecords(newDatas.length);
  };

  const prevPost = () => {
    const newPage = writePage - 1 <= 1 ? 1 : writePage - 1;
    setWritePage(newPage);
  };

  const nextPost = () => {
    const newPage =
      writePage + 1 >= totalRecords ? totalRecords : writePage + 1;
    setWritePage(newPage);
  };

  const handleChangeStepPage = (_event: any, newPage: number) => {
    setStepPage(newPage);
  };

  useEffect(() => {
    prefetchUserWrite(1);
  }, [targetMonth]);

  useEffect(() => {
    prefetchUserWrite(writePage);
  }, [writePage]);

  useEffect(() => {
    prefetchUserStep(writePage);
  }, [stepPage]);

  useEffect(() => {
    if (open) {
      refetchUserRead();
    } else {
      setTabValue(0);
      setReadType('like');
      setRequestList([]);
      setTargetMonth(getCurrentStartDate());
      setWritePage(1);
      setStepPage(1);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          minHeight: '52vh',
          minWidth: '44vw',
        },
      }}
    >
      <DialogTitle>
        <Box
          className='flex_between'
          sx={{ mb: '1rem', borderBottom: 1, borderColor: 'divider' }}
        >
          <Tabs value={tabValue} onChange={handleChange}>
            <Tab label='읽기' sx={{ width: DEFAULT_WIDTH }} />
            <Tab label='걷기' sx={{ width: DEFAULT_WIDTH }} />
            <Tab label='쓰기' sx={{ width: DEFAULT_WIDTH }} />
          </Tabs>
          <Stack
            direction={{ xs: 'column', sm: 'column', md: 'row' }}
            divider={
              <Divider
                orientation='vertical'
                flexItem
                sx={{ p: 0, m: '.5rem .5rem' }}
              />
            }
          >
            <Button
              color='info'
              onClick={() => {
                downloadItem();
              }}
            >
              데이터 다운로드
              <FileDownloadRoundedIcon color='success' />
            </Button>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>
      </DialogTitle>
      <DialogContent>
        {tabValue === 0 ? (
          <ButtonGroup
            variant='outlined'
            color='info'
            aria-label='Basic button group'
            sx={{ mb: '1rem' }}
          >
            <Button
              variant={readType === 'like' ? 'contained' : 'outlined'}
              color='info'
              onClick={() => clickReadType('like')}
            >
              읽고싶어요
            </Button>
            <Button
              variant={readType === 'historyR' ? 'contained' : 'outlined'}
              onClick={() => clickReadType('historyR')}
            >
              읽는중
            </Button>
            <Button
              variant={readType === 'historyF' ? 'contained' : 'outlined'}
              onClick={() => clickReadType('historyF')}
            >
              완독
            </Button>
          </ButtonGroup>
        ) : tabValue === 1 ? (
          <></>
        ) : (
          <></>
          // <SwSelectMonth
          //   includeAll={true}
          //   showSelectDay={false}
          //   onChangeMonth={item => {
          //     setTargetMonth(item);
          //   }}
          // />
        )}
        <Typography className='title'>
          조회 데이터 <span style={{ color: '#2581FF' }}>{totalRecords}</span>개
        </Typography>
        {tabValue === 0 ? (
          <TableContainer sx={{ height: '50vh', overflowY: 'scroll' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {(readType === 'like'
                    ? columns
                    : readType === 'historyR'
                    ? columnsR
                    : columnsF
                  ).map((column: any, idx: number) => (
                    <TableCell key={idx.toString()} sx={{ p: '.4rem .7rem' }}>
                      {column}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {requestList &&
                  requestList.length > 0 &&
                  requestList
                    .filter(
                      (row: any) =>
                        row.type === readType ||
                        `${row.type}${row.status}` === readType
                    )
                    .map((row: any) =>
                      readType === 'like'
                        ? [
                            row.title,
                            row.publisher,
                            row.author,
                            formatDateString(row.readStartDt, '/'),
                          ]
                        : readType === 'historyR'
                        ? [
                            row.title,
                            row.publisher,
                            row.author,
                            formatDateString(row.readStartDt, '/'),
                          ]
                        : [
                            row.title,
                            row.publisher,
                            row.author,
                            formatDateString(row.readStartDt, '/'),
                            formatDateString(row.readFinishDt, '/'),
                          ]
                    )
                    .map((row: any, idx: number) => (
                      <TableRow key={`book_row_key_${idx}`}>
                        {(readType === 'like'
                          ? columns
                          : readType === 'historyR'
                          ? columnsR
                          : columnsF
                        ).map((item: any, index: number) => (
                          <TableCell
                            key={`book_col_key+${index}`}
                            sx={{ p: '.7rem' }}
                          >
                            {row[index]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : tabValue === 1 ? (
          <>
            <TableContainer sx={{ height: '50vh', overflowY: 'scroll' }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {stepColumns.map((column: any, idx: number) => (
                      <TableCell key={idx.toString()} sx={{ p: '.4rem .7rem' }}>
                        {column}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {requestList &&
                    requestList.length > 0 &&
                    requestList
                      .map((row: any) => [String(row.day), String(row.step)])
                      .map((row: any, idx: number) => (
                        <TableRow key={`book_row_key_${idx}`}>
                          <TableCell key='book_col_key_1' sx={{ p: '.7rem' }}>
                            {formatDateString(
                              row[0].replaceAll('-', '').replaceAll('/', ''),
                              '/'
                            )}
                          </TableCell>
                          <TableCell key='book_col_key_2' sx={{ p: '.7rem' }}>
                            {commaFormat(row[1])}
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
            <SwPagination
              page={stepPage}
              handleChangePage={handleChangeStepPage}
              count={Math.ceil(totalRecords / stepRowsPerPage)}
            />
          </>
        ) : (
          <>
            <Box sx={{ height: '50vh', mb: '1rem' }}>
              <Divider sx={{ m: 0, p: 0 }} />
              <Box className='flex_start' sx={{ mb: '1rem' }}>
                <Box sx={{ width: '50%', height: '30%' }}>
                  <Typography className='title'>
                    {requestList &&
                      requestList.length > 0 &&
                      convert2Date(
                        requestList[0].writeDate,
                        requestList[0].writeTime
                      )}{' '}
                    {requestList &&
                      requestList.length > 0 &&
                      requestList[0].emotion !== null &&
                      requestList[0].emotion !== undefined && (
                        <span>
                          {String.fromCodePoint(
                            Number(`0x${requestList[0].emotion}`)
                          )}
                        </span>
                      )}
                  </Typography>
                  <TextField
                    sx={{
                      width: '20vw',
                      '& .MuiOutlinedInput-root': {
                        height: 'auto',
                      },
                    }}
                    rows={10}
                    aria-hidden='true'
                    multiline
                    value={
                      requestList && requestList.length > 0
                        ? requestList[0].bodyText
                        : ''
                    }
                  />
                </Box>
                <Box
                  sx={{
                    width: '50%',
                    height: '30vh',
                    mr: '.5rem',
                    color: 'warning',
                  }}
                >
                  {requestList &&
                    requestList.length > 0 &&
                    requestList[0].resourceList !== undefined &&
                    requestList[0].resourceList.length > 0 && (
                      <img
                        src={`${loginVal.value.user.cloudFront}/diary/${requestList[0].resourceList[0].resourceUrl}`}
                        alt='id'
                        height='100%'
                      />
                    )}
                </Box>
              </Box>
              <Box className='flex_start' sx={{ mb: '1rem' }}>
                {requestList &&
                  requestList.length > 0 &&
                  requestList[0].bookTitle !== null && (
                    <Box sx={{ width: '15rem', mr: '.5rem' }}>
                      <Chip
                        icon={<img src={openBookIcon} alt='map_pin' />}
                        label={requestList[0].bookTitle}
                        sx={{
                          height: 'auto',
                          '& .MuiChip-label': {
                            display: 'block',
                            whiteSpace: 'normal',
                          },
                        }}
                        variant='outlined'
                      />
                    </Box>
                  )}
                {requestList && requestList.length > 0 && requestList[0].step && (
                  <Box sx={{ width: '15rem' }}>
                    <Chip
                      icon={<img src={walkingManIcon} alt='map_pin' />}
                      label={commaFormat(requestList[0].step)}
                      sx={{
                        height: '2.75rem',
                        '& .MuiChip-label': {
                          display: 'block',
                          whiteSpace: 'normal',
                        },
                      }}
                      variant='outlined'
                    />
                  </Box>
                )}
              </Box>
              <Typography className='title'>
                {requestList &&
                  requestList.length > 0 &&
                  requestList[0].tagList &&
                  requestList[0].tagList.map((item: any) => (
                    <span>#{item.tagName}</span>
                  ))}
              </Typography>
            </Box>
            <Box className='flex_end'>
              <Button
                variant='contained'
                color='info'
                sx={{ mr: '.5rem' }}
                onClick={prevPost}
                disabled={writePage === 1}
              >
                이전글
              </Button>
              <Button
                variant='contained'
                color='info'
                onClick={nextPost}
                disabled={writePage === totalRecords}
              >
                다음글
              </Button>
            </Box>
          </>
        )}
      </DialogContent>
      {loading && <SwLoading />}
    </Dialog>
  );
};
